import React from "react";
import { NavLink } from "react-router-dom";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DoubleArrowRoundedIcon from "@material-ui/icons/DoubleArrowRounded";
import * as Dati from "../../../../Dati";
import { Trad } from "../../../../components";
import useInfoSection from "../../../hooks/InfoSection";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    link: {
        marginTop: spacing(3)
    },
    wrapper: {
        height: "100%"
    },
    valueItem: {
        textAlign: "right",
        marginRight: spacing(3)
    }
}));

interface ITabsInfoSectionProps {
    DataUrl: string;
    LinkUrl: string;
}

export const _TabsInfoSection: React.FC<ITabsInfoSectionProps> = ({ DataUrl, LinkUrl }) => {
    const classes = useStyles();
    const Data = useInfoSection(DataUrl);

    return (
        <Grid container direction="column" justify="space-between" className={classes.wrapper}>
            <Grid item>
                <Grid container spacing={1} direction={Data.length > 3 ? "row" : "column"}>
                    {Data.map((item: Dati.CDatiContesto, index: number) => (
                        <Grid item xs={12} md={6} container spacing={1} key={index}>
                            <Grid item xs={8}>
                                <Typography variant="subtitle2">{Trad.Trad(item.Etichetta)}</Typography>
                            </Grid>
                            <Grid item xs={3} className={classes.valueItem}>
                                {item.ParametroTrad ? Trad.TradParam(item.ParametroTrad, [item.Valore]) : item.Valore}
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid>
                <Button component={NavLink} variant="outlined" color="secondary" to={LinkUrl} endIcon={<DoubleArrowRoundedIcon />} className={classes.link} size="small">
                    {Trad.Trad("Visualizza")}
                </Button>
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/InfoSection/TabsInfoSection.tsx